import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

export const ServiceCard = ({ service, index }) => {
  const Icon = service.icon;
  return (
    <Reveal
      delay={(index % 4) * 0.07}
      className={service.span ? "md:col-span-2" : ""}
    >
      <Link
        to={`/services#${service.slug}`}
        data-testid={`service-card-${service.slug}`}
        className="group relative flex h-full flex-col justify-between overflow-hidden rounded-2xl border border-zinc-800 bg-ink-900/60 p-7 transition-colors duration-500 hover:border-volt/40 hover:bg-ink-900"
      >
        <div
          className="pointer-events-none absolute inset-x-0 top-0 h-px origin-left scale-x-0 bg-volt transition-transform duration-700 ease-out group-hover:scale-x-100"
          aria-hidden="true"
        />
        <div>
          <div className="flex items-start justify-between">
            <span className="flex h-11 w-11 items-center justify-center rounded-xl border border-zinc-800 bg-ink-950 text-zinc-300 transition-colors duration-500 group-hover:border-volt/30 group-hover:text-volt">
              <Icon className="h-5 w-5" />
            </span>
            <span className="font-mono text-[11px] text-zinc-600">
              {String(index + 1).padStart(2, "0")}
            </span>
          </div>
          <h3 className="mt-6 font-display text-xl font-bold tracking-tight text-zinc-100">
            {service.title}
          </h3>
          <p className="mt-2.5 text-sm leading-relaxed text-zinc-400">{service.blurb}</p>
        </div>
        <span className="mt-7 inline-flex items-center gap-1.5 font-mono text-[11px] uppercase tracking-[0.2em] text-zinc-500 transition-colors duration-300 group-hover:text-volt">
          Learn More
          <ArrowRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-1" />
        </span>
      </Link>
    </Reveal>
  );
};
